export default "__VITE_ASSET__CcM5HeJH__"